import {Stack, useMediaQuery} from "@chakra-ui/react";
import {ProfileDrawer} from "./parts/ProfileDrawer";
import React, {useState} from "react";
import {useUser} from "../../core/hooks";
import {PersonalInfo} from "./parts/PersonalInfo";
import {Payment} from "./parts/Payment";
import {Dashboard} from "./parts/Dashboard";
import Web from "./parts/Web";
import Templates from "./parts/Templates";
import Screeners from "./parts/Screeners";
import Notifications from "./parts/Notifications";
import AddScreener from "./parts/AddScreener";
import AddScreeners from "./parts/AddScreener";
import AddNotifications from "./parts/AddNotifications";
import AddTemplate from "./parts/AddTemplate";
import MenuNotification from "./parts/MenuNotification";

const Profile = () => {
    const [isLargerThan900] = useMediaQuery("(max-width: 900px)")
    const [isMobile] = useMediaQuery('(max-width: 668px)')
    const [activeTab, setActiveTab] = useState('referral')

    const {user} = useUser()
    return (
        <Stack
            maxW={
                activeTab === 'templates'
                    ? '1392px'
                    : activeTab === 'notifications' ? '1392px'
                        : activeTab === 'addTemplate' ? '1392px'
                            : activeTab === 'addScreeners' ? '1392px'
                            : activeTab === 'profile' ? '1392px'
                                : activeTab === 'menuNotif' ? '1392px'
                                    : activeTab === 'addNotifications' ? '1392px'
                                        : activeTab === 'screeners'
                                            ? '1392px'
                                            : '100%'
            }
            tr
            m={'auto'}
            px={{base: '0', md: '16px'}}
            mt={'36px'}
            flexDirection={'row'}
            spacing={'24px'}>
            {!isLargerThan900 && <ProfileDrawer
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                user={user}/>}
            {
                activeTab === 'profile' ? (
                    <PersonalInfo
                        isMobile={isMobile}
                        user={user}/>
                ) : activeTab === 'wallet' ? (
                    <Payment
                        user={user}/>
                ) : activeTab === 'web' ? (
                    <Web
                        user={user}/>
                ) : activeTab === 'templates' ? (
                    <Templates
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'screeners' ? (
                    <Screeners
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'notifications' ? (
                    <Notifications
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'addScreeners' ? (
                    <AddScreeners
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'addNotifications' ? (
                    <AddNotifications
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'addTemplate' ? (
                    <AddTemplate
                        setActiveTab={setActiveTab}
                        user={user}/>
                ) : activeTab === 'menuNotif' ? (
                        <MenuNotification
                            user={user}/>
                    )
                    : <Dashboard
                        isMobile={isMobile}
                        user={user}/>
            }

        </Stack>
    )
}

export default Profile